import React, { useState , useEffect}  from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import { useStateContext } from '../../contexts/ContextProvider';
import { useTicketsMutations } from '../../hooks';
import { getUsuariosSucursal } from '../../services/UsuarioSucursal';
import { FooterPages } from '..';
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';
import { fetchUser } from '../../utils/fetchUser';

const initialState = {
empresa:'',
tipo: 'Requerimiento',
numTicket: '',
requerimiento: '',
observacion: '',
documentosRespaldo:[],
fechaEntrega: null,
fechaCreacion: new Date(),
idCreador: null,
idAsignado: null,
estado: 'Pendiente',
};

const NuevoTicketsLF = ({vecinoData, onChangeVecino}) => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();
  const [formData, setFormData] = useState(initialState);
  const [usuarioData, setUsuarioData] = useState([]);
  const [pdfFiles, setPdfFiles] = useState([]);
  const { addTicket, updateTicketC } = useTicketsMutations();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Nada')); // Fecha inicial getFirstDayOfMonth('Fin')
  const userInfo = fetchUser();
  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";

  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  useEffect(() => {
    if(vecinoData) {
      setFormData(vecinoData);
      setSelectedDate(vecinoData.fechaEntrega !== null ? new Date(vecinoData.fechaEntrega) : getFirstDayOfMonth('Nada'));
    }

  }, [vecinoData]);

useEffect( () => {
  const fetchData = async () => { 
    const misUsuario = await getUsuariosSucursal();
    setUsuarioData(misUsuario);
  };
  fetchData();
},[]);

  const handleChange = (e) =>{
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const FileUpload = ({ onFilesUpload }) => {
    const handleFilesChange = (event) => {
      const files = event.target.files;
  
      if (files.length > 0) {
        const readers = Array.from(files).map((file) => {
          const reader = new FileReader();
  
          return new Promise((resolve) => {
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.readAsDataURL(file);
          });
        });
  
        Promise.all(readers).then((base64Array) => {
          onFilesUpload(base64Array);
        });
      }
    };
  
    return (
      <input
        type="file"
        accept=".pdf"
        onChange={handleFilesChange}
        multiple
      />
    );
  };

  const handleDateObraChange = (date) => {
    setSelectedDate(date);
  };

  const handleFilesUpload = (base64Array) => {
    setPdfFiles([...pdfFiles, ...base64Array]);
  };

  const handleSubmit = async (e) =>{
    e.preventDefault();

    if(!vecinoData._id) 
    {
      const dataBase = {
        empresa: userInfo.empresa,
        tipo: 'Requerimiento',
        numTicket: 0, // Número secuencial
        requerimiento: formData.requerimiento,
        observacion: formData.observacion,
        documentosRespaldo: pdfFiles,
        fechaEntrega: selectedDate.toISOString(),
        fechaCreacion: new Date().toISOString(),
        idCreador: userInfo.usuario,
        idAsignado: userInfo.usuario,
        estado: formData.estado
      };
      // console.log('crear VECINO');
       await addTicket.mutateAsync( dataBase );
    } else
    { 
      const dataBase = {
        _id: vecinoData._id,
        empresa: userInfo.empresa,
        tipo: 'Requerimiento',
        requerimiento: formData.requerimiento,
        observacion: formData.observacion,
        documentosRespaldo: pdfFiles,
        fechaEntrega: selectedDate.toISOString(),
        fechaCreacion: new Date().toISOString(),
        idCreador: formData.idCreador,
        idAsignado: formData.idAsignado,
        estado: formData.estado
      };
       await updateTicketC.mutateAsync( dataBase );
    };
    onChangeVecino('REFRESH');
    setIsClicked( !isClicked.nuevoTicket );

  }
  
  return (
    <form  onSubmit={handleSubmit} >
     <div className="bg-half-transparent w-full fixed nav-item top-0 right-0">
        <div className="overflow-y-scroll float-right h-screen duration-1000 ease-in-out dark:text-gray-200 transition-all dark:bg-[#484B52] bg-gray-100  w-full md:w-3/4 p-8">
          
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
          <div className="flex items-center gap-2">
            <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                {!vecinoData ? "Nuevo" : "Editar"} Ticket
              </p>
            </div>

            <button
              type="button"
              onClick={() => setIsClicked(!isClicked.nuevoTicket)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-150 p-2 rounded-full hover:bg-gray-100"
              aria-label="Cerrar"
            >
              <MdOutlineCancel className="text-xl md:text-2xl" />
            </button>
          </div>
          
          <div className="mt-5 space-y-4">

            <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                <div className="grid grid-cols-4 md:grid-cols-5 gap-4" >
                    <div className="flex flex-col ">
                        <label className="text-xs font-semibold mb-1">N° TIcket</label>
                        <input
                            type="text"
                            className={inputClass}
                            placeholder=""
                            name="numTicket"
                            value= {formData.numTicket}
                            disabled
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-span-2">
                      <div className="flex flex-col ">
                            <label className="text-xs font-semibold mb-1">Creado por</label>
                            <select className={inputClass} disabled name="idCreador"
                                value={formData.idCreador} onChange={handleChange}>
                              <option value=""></option>
                              {usuarioData?.map((item, index) => (
                                <option  key={item._id} value={item._id}>{item.nombre}</option>
                              ))}  
                            </select>
            
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <label className="text-xs font-semibold mb-1">Estado</label>
                        <select className={inputClass} name="estado" value= {formData.estado} required onChange={handleChange}>
                            <option value="Pendiente">Pendiente</option>
                            <option value="Cancelado">Cancelado</option>
                            <option value="Finalizado">Finalizado</option>
                        </select>
                    </div>
                    <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Fecha Entrega</label>
                      <SeleccionaFecha
                        selectedDate={selectedDate}
                        handleDateChange={handleDateObraChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-5" >
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Requerimiento</label>
                      <input
                        type="text"
                        className={inputClass}
                        placeholder=""
                        name="requerimiento"
                        value= {formData.requerimiento}
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4 mt-5" >
                    <div className="flex flex-col ">
                      <label className="text-xs font-semibold mb-1">Observación</label>
                      <textarea
                        className="text-xs border-gray-200 outline-none border-2 p-2  focus:border-gray-300 h-48 max-h-96"
                        type="text"
                        placeholder=""
                        name="observacion"
                        value= {formData.observacion}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-5" >
                    <div className="col-span-2">  
                      <div className="flex flex-col">
                          <label className="text-xs font-semibold mb-1">Adjuntos</label>
                          <FileUpload onFilesUpload={handleFilesUpload} />
                      </div>
                    </div> 
                </div> 
                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mt-5" >
                  <div className="col-span-2">
                      <div className="flex flex-col ">
                        <label className="text-xs font-semibold mb-1">Asignado a</label>
                        <select className={inputClass} disabled name="idAsignado"
                            value={formData.idAsignado} onChange={handleChange}>
                          <option value=""></option>
                          {usuarioData?.map((item, index) => (
                            <option  key={item._id} value={item._id}>{item.nombre}</option>
                          ))}  
                        </select>
                      </div>
                  </div>

                </div>
              </div>
                    <div className="bg-white p-6 rounded-lg shadow-lg items-end">
                        <button
                            onClick={handleSubmit}
                            className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                        >
                         {!vecinoData ? "Crear Nuevo": "Guardar Cambios"}
                        </button>
                    </div>

              <FooterPages />  
          </div>

        </div>
      </div>
    </form>
  );
};

export default NuevoTicketsLF;